import { Settings } from "../../Settings";
import Fast from "../../util/Fast";
import Character from "../character/Character";
import Vector from "../math/Vector";

//const characterHalfWidth = 5;

export default class Collision {
    constructor() {        
        /**
         * @constant
         * @type {Vector}
         */
        this.collisionVector = new Vector(0, 0);
        // /**
        //  * @constant
        //  * @type {number}
        //  */
        // this.characterSpriteLeftMargin = 3; // left edge of character image is 3 pixels from edge of the sprite
        // /**
        //  * @constant
        //  * @type {number}
        //  */
        // this.characterSpriteRightMargin = 3; // right edge of character image is 3 pixels from edge of the sprite
    }

    // /**
    //  * @private
    //  * @param {number} a0 
    //  * @param {number} a1 
    //  * @param {number} b0 
    //  * @param {number} b1 
    //  * @returns {boolean}
    //  */
    // static isIntersection(a0, a1, b0, b1) {
    //     // a0 in [b0-b1]
    //     // a1 in [b0-b1]
    //     // b0 in [a0-a1]
    //     // b1 in [a0-a1]
    //     return (b0 < a0 && a0 < b1) || (b0 < a1 && a1 < b1) || (a0 < b0 && b0 < a1) || (a0 < b1 && b1 < a1);
    // }

    /**
     * @param {Character} character 
     * @returns {boolean}
     */
    static isStandingOnTileOrigin(character) {
        const tile = character.position.tile;
        if (!tile) {
            return true; // not sure what to say here.
        }

        // The world coordinate can have non-integer values, so let's use a
        // cast version of the y-coordinate.
        const worldCoordinate = character.position.worldCoordinateOrigin; 
        const yCoordInteger = Fast.floor(worldCoordinate.y);

        // If our world y-coordinate is not the same as the tile origin, then we are mid-tile.
        return yCoordInteger === tile.origin.y;
    }

    /**
     * @param {Character} character 
     * @returns {boolean}
     */
    static isStandingOnTopOfClosedTile(character) {
        const tile = character.position.tile;
        if (!tile) {
            return true;
        }

        // The world coordinate can have non-integer values, so let's use a
        // cast version of the y-coordinate.
        const worldCoordinate = character.position.worldCoordinateOrigin; 
        const yCoordInteger = Fast.floor(worldCoordinate.y);

        // If our world y-coordinate is not the same as the tile origin, then we are mid-tile,
        // and definitely not standing on top of a tile.
        if (yCoordInteger !== tile.origin.y) {
            return false;
        }

        const neighborBottom = tile.getNeighborBottom();
        return neighborBottom && !neighborBottom.isTraversable();
    }

    /**
     * If the character were to move N pixels down, would they collide with something?
     * @param {Character} character 
     * @param {number} movementPixels 
     * @returns {boolean}
     */
    isCollisionDown(character, movementPixels) {
        const tile = character.position.tile;
        if (!tile) {
            return true;
        }
        
        const bottomTile = tile.getNeighborBottom();
        if (!bottomTile) {
            return true;
        }

        if (bottomTile.open) {
            return false;
        }

        // Get the 'foot' coordiante of the character after the move.
        const movedY = character.position.worldCoordinateOrigin.y + Settings.tile.size + movementPixels;

        if (tile.containsXY(character.position.worldCoordinateOrigin.x, movedY)) {
            return !tile.open;
        }
        else if (bottomTile.containsXY(character.position.worldCoordinateOrigin.x, movedY)) {
            return !bottomTile.open;
        }


        // // If we are exactly at the origin of our tile,
        // if (y === tile.origin.y) {
        //     return !bottomTile.open;
        // }

        // // the origin is the top left corner. The bottom is the top + size.
        // const tileOriginY = tile.origin.y;
        // const tileEndY = tileOriginY + Settings.tile.size;



        // if (movedY + movementPixels < tileEndY) {
        //     // We are still within our tile.
        //     return false;
        // }
        // else {
        //     const neighborBottom = tile.getNeighborBottom();
        //     if (!neighborBottom || !neighborBottom.isTraversable()) {
        //         return true;
        //     }
        // }
        return false;
    }
}